export const DEVICE_FROM = {
    DEVICE_SCINENER:{
        from:'科技侠',
        value:1
    },
    DEVICE_WEIGONG:{
        from:'微耕',
        value:2
    },
    DEVICE_XP:{
        from:'芯烨',
        value:3
    },
    DEVICE_CORX:{
        from:'科兴',
        value:4
    },
    DEVICE_BLH:{
        from:'百励华',
        value:5
    },
    DEVICE_SKY:{
        from:'太空云',
        value:6
    }
}